import { render, staticRenderFns } from "./QLoader.vue?vue&type=template&id=71887bd4&scoped=true"
import script from "./QLoader.vue?vue&type=script&lang=ts"
export * from "./QLoader.vue?vue&type=script&lang=ts"
import style0 from "./QLoader.vue?vue&type=style&index=0&id=71887bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71887bd4",
  null
  
)

export default component.exports